import {getUserById} from '../../utils/services'

const userCache = {}

export async function waitForCachedUser(id, includeInactive, tokenProvider, profileApiUrl) {
    if (!userCache[id]) {
        userCache[id] = await getUserById(id, includeInactive, tokenProvider, profileApiUrl)
    }
    return userCache[id]
}

export async function waitForCachedUsers(ids, includeInactive, tokenProvider, profileApiUrl) {
    const users = await Promise.all(
        ids.map((id) => waitForCachedUser(id, includeInactive, tokenProvider, profileApiUrl))
    )
    return users
}

export function getCachedUser(id, includeInactive, tokenProvider, profileApiUrl) {
    const user = userCache[id]
    if (!user) {
        waitForCachedUser(id, includeInactive, tokenProvider, profileApiUrl).catch((err) =>
            console.error('Error retrieving user information: ', err)
        )
    }
    return user
}
